import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { useBridgeAPI, useBridgeState } from '@digitaz/bridge-sdk-client';
import { Icon } from '../Icon';
import Plus from '../../public/static/images/green-plus.svg';
import CloseWebview from '../../public/static/images/close-webview.svg';
import {
  setAdriverSelectedCity,
  setChosenLocationNames,
  setCurrentState,
  setLocationIds,
  switchTab,
  toggleAddNewItemModal,
  togglePromotionModalView
} from '../../actions';
import { useNewItemLocalState } from '../../hooks/useNewItemLocalState';
import { BackButton } from '../BackButton';
import { Cities } from '../../utils/helpers/constants';
import {
  WhiteHeaderTitle,
  WhiteHeaderContainer,
  WhiteHeaderWebviewBtn
} from './styled';
import { StyledLogoIcon } from '../HamburgerMenu/styled';

interface WhiteHeaderProps {
  noBorder?: boolean;
  headerTitle?: string;
  isFixedHeader?: boolean;
  isShowBackButton?: boolean;
  isShowCloseButton?: boolean;
}

export const WhiteHeader: React.FC<WhiteHeaderProps> = ({
  noBorder,
  headerTitle = '',
  isFixedHeader,
  isShowBackButton,
  isShowCloseButton
}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { isWebView } = useBridgeState();
  const { closeWebview } = useBridgeAPI();
  const { setFirstViewValue } = useNewItemLocalState();

  const isMain = !headerTitle && !isShowBackButton;

  const clickHandle = () => {
    dispatch(switchTab(0));
    dispatch(setChosenLocationNames([]));
    dispatch(setLocationIds([]));
    dispatch(setCurrentState(null));
    dispatch(setAdriverSelectedCity(Cities.Baku.az));
    dispatch(togglePromotionModalView(false));

    return router.push('/');
  };

  const openCreateNewItemForm = () => {
    dispatch(toggleAddNewItemModal(true));
    setFirstViewValue('false');
  };

  const getIcon = () => {
    switch (true) {
      case isWebView:
        if (!isShowCloseButton) return null;
        return (
          <WhiteHeaderWebviewBtn onClick={closeWebview}>
            <i>
              <Icon
                IconComponent={CloseWebview}
                width={15}
                height={15}
                indent={false}
                color={'#a9a39e'}
              />
            </i>
          </WhiteHeaderWebviewBtn>
        );
      case isShowBackButton:
        return null;
      default:
        return (
          <div
            role="button"
            tabIndex={0}
            onClick={openCreateNewItemForm}
            onKeyPress={openCreateNewItemForm}
            data-cy="white-header-new-btn"
            data-stat="header-new-btn"
          >
            <Icon IconComponent={Plus} width={30} height={30} indent={false} />
          </div>
        );
    }
  };

  return (
    <WhiteHeaderContainer
      id="white-header"
      data-cy="white-header"
      $isMain={isMain}
      $isFixed={isFixedHeader}
      $isCenter={isShowBackButton}
      $noBorder={noBorder}
    >
      {isShowBackButton && <BackButton />}
      {headerTitle ? (
        <WhiteHeaderTitle tag="h3" data-cy="white-header-title">
          {headerTitle}
        </WhiteHeaderTitle>
      ) : (
        <>
          <a
            data-cy="white-header-logo"
            data-stat="header-logo"
            onClick={clickHandle}
            onKeyPress={clickHandle}
            role="button"
            tabIndex={-1}
          >
            <Icon IconComponent={StyledLogoIcon} width={85} height={19} />
          </a>
          {getIcon()}
        </>
      )}
    </WhiteHeaderContainer>
  );
};
